const STEPS = [
  {
    icon: 'ri-eye-off-line',
    title: '不要求实名',
    desc: '投稿全程无需真实姓名、手机号或任何身份信息，你想说多少，就说多少。',
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: '材料脱敏',
    desc: '涉及个人定位的截图、文件名与时间戳，上线前都会统一脱敏处理。',
  },
  {
    icon: 'ri-file-user-line',
    title: '最小化采集',
    desc: '我们只取报道所需的事实片段，不收集与事实无关的个人背景。',
  },
  {
    icon: 'ri-verified-badge-line',
    title: '多轮复核',
    desc: '重要线索由多人独立复核引用口径，避免因表述偏差伤及无辜。',
  },
];

export default function Protect() {
  return (
    <section id="protect" className="scroll-mt-20 bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">PROTECTION</span>
            <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
              你的勇气，值得被认真保护
            </h2>
            <p className="mt-3 max-w-xl text-[15px] leading-7 text-foreground-700">
              说真话需要勇气，而让真话不伤害说的人，是我们的责任。从线索提交到报道上线，每一步我们都把
              <span className="font-semibold text-foreground-900">“隐私与安全”</span>放在首位。
              我们不会为了流量牺牲任何一个爆料者的安全。
            </p>
            <div className="mt-6 rounded-lg bg-accent-500 px-5 py-4 text-background-50">
              <p className="flex items-start gap-2 text-sm font-medium">
                <i className="ri-questionnaire-line mt-0.5 text-lg" aria-hidden="true"></i>
                小提示：不要在投稿内容中主动填写工作单位工号、个人真实姓名等非必要信息，越少越好。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {STEPS.map((s) => (
              <div
                key={s.title}
                className="rounded-lg bg-background-50 p-5 ring-1 ring-background-200 transition-colors hover:ring-accent-300"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${s.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-3 font-display text-base font-bold text-foreground-900">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}